import request from '@/utils/request'

export const listCsSessions = (params) => {
  return request.get('/admin/cs/sessions', { params })
}

export const getCsSessionUnreadTotal = () => {
  return request.get('/admin/cs/sessions/unread-total')
}

export const listCsSessionMessages = (id, params) => {
  return request.get(`/admin/cs/sessions/${id}/messages`, { params })
}

export const replyCsSession = (id, payload) => {
  return request.post(`/admin/cs/sessions/${id}/messages`, payload)
}

export const markCsSessionRead = (id) => {
  return request.post(`/admin/cs/sessions/${id}/read`)
}

export const deleteCsMessage = (id) => {
  return request.delete(`/admin/cs/messages/${id}`)
}
